import { __extends } from "tslib";
import React from 'react';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import classnames from 'classnames';
import Input from '../../../Input';
import IconButton from '../../../Button/IconButton';
import SearchIcon from '../../../Icons/Search';
import { IconSize } from '../../../Icons/IconWrap';
import withCurrentMediaSource from '../../_hocs/withCurrentMediaSource';
import withSearch from '../../_hocs/withSearch';
import { MediaSourceType } from '../../types';
import { withMobileContext } from '../../../Context';
import s from './SearchInput.scss';
var enhance = compose(withCurrentMediaSource, withSearch, withMobileContext, withTranslation());
var SearchInput = /** @class */ (function (_super) {
    __extends(SearchInput, _super);
    function SearchInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isFocused: false,
        };
        _this.refInput = function (input) {
            _this.inputRef = input;
        };
        _this.onChange = function (value) {
            _this.props.setSearchInput(value);
        };
        _this.onKeyPress = function (event) {
            if (event.key === 'Enter') {
                _this.handleSearch(event.target.value);
            }
        };
        _this.onBlur = function () {
            _this.setState({ isFocused: false });
            if (_this.props.isMobile) {
                _this.handleSearch(_this.props.searchInput);
            }
        };
        _this.onSearchClick = function () {
            _this.setState({ isFocused: true });
            _this.handleSearch(_this.props.searchInput);
        };
        return _this;
    }
    SearchInput.prototype.componentDidUpdate = function (prevState) {
        if (this.state.isFocused && !prevState.isFocused) {
            this.inputRef.focus();
        }
    };
    SearchInput.prototype.render = function () {
        var _a = this.props, t = _a.t, searchInput = _a.searchInput, currentMediaSource = _a.currentMediaSource, isMobile = _a.isMobile;
        var isFocused = this.state.isFocused;
        if (currentMediaSource === MediaSourceType.STASH ||
            currentMediaSource === MediaSourceType.COLLECTION) {
            return null; // stash and faves don't support searching
        }
        var isActive = isFocused || searchInput;
        return (React.createElement("div", { className: classnames(s['root'], isActive && s['active'], this.props.className) },
            (!isMobile || isActive) && (React.createElement(Input, { refInput: this.refInput, fullWidth: isMobile, skin: { bar: s['input-bar'] }, placeholder: t('mediapopup.searchForDeviations'), value: searchInput, onChange: this.onChange, onKeyPress: this.onKeyPress, onBlur: this.onBlur })),
            React.createElement(IconButton, { className: s['button'], onClick: this.onSearchClick },
                React.createElement(SearchIcon, { withPadding: true, size: isMobile ? IconSize.MEDIUM : IconSize.SMALL }))));
    };
    SearchInput.prototype.handleSearch = function (searchInput) {
        if (searchInput) {
            this.props.setSearchQuery(searchInput);
        }
    };
    return SearchInput;
}(React.Component));
export { SearchInput };
export default enhance(SearchInput);
//# sourceMappingURL=SearchInput.connected.js.map